import { defineComponent as _defineComponent } from 'vue'
import {onMounted, ref} from "vue";
import {useRoute, useRouter} from 'vue-router/composables'
import i18n from "@/i18n";
import {store} from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'WarrantyView',
  setup(__props) {

const message = ref<string|(string | null)[]>('')
const messageType = ref<string|(string | null)[]>('')
const snackbar = ref<boolean>(false)
const quickSearchLoading = ref<boolean>(false)

const router = useRouter()
const route = useRoute()

onMounted(() => {
  if (route.query.message) {
    displayMessage(route.query.message)
    router.replace(router.currentRoute.path)
  }
})
const search = () => {
  router.push({
    name: 'warranty_users',
    // @ts-ignore
    query: store.warrantySearchModel
  })

  quickSearchLoading.value = true
}
const displayMessage = (messageString:string|(string | null)[], type:string = 'warning') => {
  message.value = messageString
  messageType.value = type
  snackbar.value = true
}

return { __sfc: true,message, messageType, snackbar, quickSearchLoading, router, route, search, displayMessage, i18n, store }
}

})